import { showModal } from 'lib/components/Modal';
import { ORDER_STATE } from 'lib/constants/order';
import { OrderingDialog } from 'lib/container/Ordering';
import { useUserOrderStore } from 'lib/store/userOrderStore';
import { addReportPublicParams } from 'lib/utils/dataReport';
import awardPrizeService from './awardPrizeService';

class UserOrderService {
  private userOrderStore: any;
  constructor() {
    // 只能拿到静态值，更新后的值无法及时获取
    this.userOrderStore = useUserOrderStore.getState();
  }

  public getUserOrderInfo() {
    return useUserOrderStore.getState().userOrderInfo;
  }

  public async handleUserOrderInfo(channelCode: string) {
    // 请求用户订单数据
    const orderInfo = (await this.userOrderStore.queryUserOrderInfo(channelCode)) || {};
    addReportPublicParams({
      operatorType: orderInfo.operatorType,
      product: orderInfo.pId,
      orderState: orderInfo.orderState >= 12 ? 2 : 1,
      mobile: orderInfo.orderMobile,
    });
    // 处理订购数据
    switch (orderInfo?.orderState) {
      case ORDER_STATE.ORDERING: {
        // 提示弹窗
        showModal(OrderingDialog());
        break;
      }
      case ORDER_STATE.ORDER_SUCCESS:
      case ORDER_STATE.CANCELING:
      case ORDER_STATE.CANCEL_SUCCESS: {
        // 订购完之后，获取到活动ID，判断是否奖品被领取
        const handleQueryPrizeStatus = async () => {
          const waitForReceiveList = await awardPrizeService.getWaitForReceiveGiftData();
          if (!waitForReceiveList?.length) return;
          return;
        };
        // 这里需要等待权益礼包确定采用哪个运营商的活动ID后，统一进行领奖状态查询
        setTimeout(() => {
          handleQueryPrizeStatus();
        }, 300);
        break;
      }
    }
  }
}

const userOrderService = new UserOrderService();

export default userOrderService;
